module.exports = __webpack_public_path__ + "img/parteight_pic1.56aad8f1.png";